import { AppTheme } from "../../theme"

export const createLoginPageStyles = (theme: AppTheme) => {
    return {
        logo2: {
            height: 'auto',
            width: {
                xs: '110%',
                sm: '90%',
                md: '80%',
                lg: '70%',
            },
        },
        mainPaper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignSelf: 'center',
            alignItems: 'center',
            width: {
                xs: '80%',
                sm: '70%',
                md: '50%',
                lg: '30%',
            },
            borderRadius: '15px',
            padding: { xs: '10px', sm: '20px', md: '30px', lg: '40px' },
        },
        textField: {
            width: {
                xs: "85%",
                sm: '472px',
            }
        },
        buttonLogin: {
            width: {
                xs: "85%",
                sm: '472px',
            },
            height: "50px"
        },
        content: {
            height: "100vh", 
            maxWidth: "unset", 
            p: 0, 
            backgroundColor: theme.palette.neutral_5
        },
        leftPanel: {
            height: "100vh",
            backgroundColor: theme.palette.loginBackground,
            backgroundSize: "contain",
            display: {
                xs: 'none',
                sm: 'none',
                md: "none",
                lg: "flex"
            },
            flexDirection: "column"
        },
        logoBox: {
            width: "40%",
            display: "flex",
            justifyContent: "center",
        },
        logo: {
            flex: 1,
            height: 160,
            backgroundImage: `url(/assets/images/${theme.applogoLogin})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
        },
        icon: {
            ml: "-12vw",
            minWidth: "120%",
            minHeight: "100vw",
            opacity: "0.4",
            backgroundImage: `url(/assets/images/icon_lotia.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
        },
        boxLogo: {
            width: '100%',
            height: 120,
            top: 50,
            display: "flex",
            justifyContent: 'center',
            mt: {
                xs: "200px",
                sm: "200px",
                md: "0"
            }
        },
        viewOnMobile: {
            display: {
                xs: "flex",
                sm: "flex",
                md: "flex",
                lg: "none"
            }
        },
        logoCell: {
            width: 140,
            height: 140,
            backgroundImage: `url(/assets/images/${theme.applogo})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
        },
    }
};
